import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "../../css_files/Master/AddCustomerPricingMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";

function AddCustomerPricingMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  customerpricingupdatedata,
}) {
  const [customerPricingData, setCustomerPricingData] = useState({
    Code: triggerupdate ? customerpricingupdatedata?.code : "",
    Percentage: triggerupdate ? customerpricingupdatedata?.percentage : "",
    Description: triggerupdate ? customerpricingupdatedata?.description : "",
  });

  const [codesPercentage, setCodesPercentage] = useState({
    A: "",
    B: "",
  });

  const [loading, setloading] = useState(false);

  function handleCustomerCodePercentage(code) {
    switch (code) {
      case "A":
        return parseFloat(customerPricingData.Percentage);
      case "B":
        return (
          parseFloat(customerPricingData.Percentage) +
          parseFloat(codesPercentage.A || "0")
        );
      case "C":
        return (
          parseFloat(customerPricingData.Percentage) +
          parseFloat(codesPercentage.A || "0") +
          parseFloat(codesPercentage.B || "0")
        );
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/CustomerPricing/UpdateCustomerPricing`;
      const percentage = handleCustomerCodePercentage(customerPricingData.Code);
      axiosInstance
        .post(url, {
          id: customerpricingupdatedata.id,
          Code: customerPricingData.Code,
          Percentage: percentage > 100.0 ? 100 : percentage,
          Description: customerPricingData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/CustomerPricing`;
      const percentage = handleCustomerCodePercentage(customerPricingData.Code);
      axiosInstance
        .post(URL, {
          ...customerPricingData,
          Percentage: percentage > 100.0 ? 100 : percentage,
        })
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error(error);
          if (error.status === 500)
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          else
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });

          setloading(false);
        });
    }
  }

  function getCustomerPricings() {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/CustomerPricing`)
      .then((res) => {
        setCodesPercentage({
          A: res.data.find((x) => x.code === "A")?.percentage,
          B: res.data.find((x) => x.code === "B")?.percentage,
        });
      })
      .catch(console.log);
  }

  return (
    <form className="add-customer-pricing-master" onSubmit={handleSubmit}>
      <aside>
        <blockquote>
          <label>
            Customer Code{" "}
            <i
              className="fa-solid fa-info-circle"
              title="Selecting Code 'B' or 'C' adds percentage of Priority Codes. E.g. Choosing Code 'B' add up percentage of Code 'A' and Choosing Code 'C' will Add Up percentage of Code 'A' and 'B'"
            ></i>{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <select
            onChange={(e) => {
              setCustomerPricingData({
                ...customerPricingData,
                Code: e.target.value,
              });
              getCustomerPricings();
            }}
            required
          >
            <option value="">Select Customer Code</option>
            <option value="A" selected={customerPricingData.Code === "A"}>
              A
            </option>
            <option value="B" selected={customerPricingData.Code === "B"}>
              B
            </option>
            <option value="C" selected={customerPricingData.Code === "C"}>
              C
            </option>
          </select>
        </blockquote>
        <blockquote>
          <label>
            Rate (Percentage){" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <input
            type="text"
            placeholder="Enter Rate"
            value={customerPricingData.Percentage}
            onChange={(e) => {
              setCustomerPricingData({
                ...customerPricingData,
                Percentage: e.target.value > 100.0 ? 100.0 : e.target.value,
              });
            }}
            required
            onInput={(e) => {
              e.target.value = e.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/^(\d{3,})\d/g, "$1")
                .replace(/(\..*?)\./g, "$1")
                .replace(/^(\d{0,3})(\.\d{0,2})?.*$/, "$1$2");
            }}
          />
        </blockquote>
      </aside>
      <blockquote>
        <label>Description </label>
        <textarea
          rows={4}
          placeholder="Description (Maximum 400 Characters)"
          value={customerPricingData.Description}
          onChange={(e) =>
            setCustomerPricingData({
              ...customerPricingData,
              Description: e.target.value,
            })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
        />
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"}</button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddCustomerPricingMaster;
